/**
 * The last JavaScript error this page saw, for the feedback form to attach.
 *
 * <b>Why this exists.</b> Most «det virket ikke» has an exception behind it that the merchant never
 * sees and could not describe if they did. One line of it turns an unreproducible report into a
 * stack-trace search.
 *
 * Deliberately one error and no history: this is a hint for a human reading a report, not telemetry.
 * Nothing is sent anywhere until a merchant writes a message and presses Send.
 */
let last = '';

export function recordClientErrors() {
    window.addEventListener('error', (event) => {
        const where = event.filename ? ' (' + event.filename + ':' + event.lineno + ')' : '';
        last = String(event.message || 'Error') + where;
    });
    window.addEventListener('unhandledrejection', (event) => {
        const reason = event.reason;
        last = 'Unhandled rejection: ' + String((reason && reason.message) || reason || '');
    });
}

export function lastClientError() {
    return last;
}
